import React from 'react'
import PropTypes from 'prop-types'
import { S, PRIMARY } from './styles'

export default function DataTable({ rows, onNavigate }) {
  if (!rows || rows.length === 0) return null
  const cols = Object.keys(rows[0])

  const renderCell = (col, value) => {
    if (col === 'Page' && typeof value === 'string' && value.startsWith('/')) {
      return (
        <button
          style={{
            padding: '2px 8px',
            background: PRIMARY,
            color: '#fff',
            border: 'none',
            borderRadius: 12,
            fontSize: 11,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
          onClick={() => (onNavigate ? onNavigate(value) : window.open('/#' + value, '_blank'))}
        >
          Open →
        </button>
      )
    }
    return value ?? '\u2014'
  }

  return (
    <div style={{ overflowX: 'auto', marginTop: 4 }}>
      <table style={S.table}>
        <thead>
          <tr>
            {cols.map((c) => (
              <th key={c} style={S.th}>
                {c}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} style={i % 2 === 0 ? {} : S.trEven}>
              {cols.map((c) => (
                <td key={c} style={S.td} title={String(row[c] ?? '')}>
                  {renderCell(c, row[c])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

DataTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object),
  onNavigate: PropTypes.func,
}
